export enum DocumentRadioCertificate {
  IdentityCard = 'id',
  Other = 'other',
  Witness = 'witness',
}
